export function farloUiContentSlider(element) {
  if (!element) return;

  const wrap = element.closest('.content-slider');
  if (!wrap) return;

  let flkty;

  element.classList.remove('flickity-enabled', 'is-draggable');

  imagesLoaded(element, init);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (flkty) flkty.resize();
    }, 150);
  });

  function init() {
    if (flkty) flkty.destroy();

    flkty = new Flickity(element, {
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      draggable: true,
      adaptiveHeight: false,
    });

    flkty.on('ready', updateUI);
    flkty.on('change', updateUI);

    flkty.on('change', () => wrap.classList.toggle('alt-shape'));

    flkty.resize();
    setTimeout(() => flkty.resize(), 100);
  }

  function updateUI() {
    if (!flkty) return;
    // optional future UI sync
  }

  // ✅ EVENT DELEGATION
  wrap.addEventListener('click', (e) => {
    const prev = e.target.closest('.carousel-prev');
    const next = e.target.closest('.carousel-next');

    if (!flkty) return;

    if (prev) {
      flkty.previous();
    }

    if (next) {
      flkty.next();
    }
  });
}
